import { FC } from 'react';
import cx from 'classnames';
import styles from './InjuryPeriodFilter.module.scss';

/** Periodo di analisi per i pannelli Fastidi/Storico clinico (atleta e team). */
export type InjuryPeriod = '1m' | '3m' | '6m' | 'season' | 'all';

export interface InjuryPeriodOption {
  value: InjuryPeriod;
  label: string;
}

/**
 * Opzioni canoniche del filtro periodo, stesso set e stesse label già in uso
 * (duplicate, con stile hardcoded) in `PlayerDetail.tsx`/`TeamDetail.tsx`
 * per il tab "Storico clinico".
 */
export const INJURY_PERIOD_OPTIONS: InjuryPeriodOption[] = [
  { value: '1m', label: 'Ultimo mese' },
  { value: '3m', label: '3 mesi' },
  { value: '6m', label: '6 mesi' },
  { value: 'season', label: 'Stagione' },
  { value: 'all', label: 'Tutto' },
];

interface InjuryPeriodFilterProps {
  value: InjuryPeriod;
  onChange: (period: InjuryPeriod) => void;
  /** Sottoinsieme/ordine custom delle chip; default: le 5 opzioni canoniche. */
  options?: InjuryPeriodOption[];
}

/**
 * Chip di selezione periodo per i pannelli Fastidi/Storico clinico.
 * Sostituisce i bottoni inline (hex fissi + `'Satoshi:Medium'` non valido,
 * non dark-ready) duplicati nei cluster: qui i colori sono token-based
 * (`_theme-mixins.scss`), stessa forma della `.viewToggle` di `TeamDetail`.
 */
const InjuryPeriodFilter: FC<InjuryPeriodFilterProps> = ({
  value,
  onChange,
  options = INJURY_PERIOD_OPTIONS,
}) => (
  <div className={styles.periodFilter} role="group" aria-label="Filtro periodo">
    {options.map((opt) => (
      <button
        key={opt.value}
        type="button"
        className={cx(styles.chip, { [styles.chipActive]: value === opt.value })}
        aria-pressed={value === opt.value}
        onClick={() => onChange(opt.value)}
      >
        {opt.label}
      </button>
    ))}
  </div>
);

export default InjuryPeriodFilter;
